import { useEffect } from 'react';
import { useNavigate } from 'react-router';

// The key the path is kept under. Session storage, so it lives as long as
// the tab and no longer, and never travels in a URL.
const key = 'psy.returnTo';

// Keeps the path a signed-out visitor was going to. Storage can be refused
// (a private window, blocked site data); the link then simply lands on the
// home page, which is what happened before anything was remembered.
export function remember(path) {
  try {
    sessionStorage.setItem(key, path);
  } catch {
    return;
  }
}

// The kept path, removed as it is read so it opens once.
function take() {
  try {
    const path = sessionStorage.getItem(key);

    sessionStorage.removeItem(key);

    return path;
  } catch {
    return;
  }
}

// Once someone is signed in and onboarded, opens the path they were going to
// before they had to sign in, once, replacing the home page the sign-in
// landed on so Back does not return to it.
export function ReturnToPath() {
  const navigate = useNavigate();

  useEffect(function() {
    const path = take();

    if (path == null) {
      return;
    }

    navigate(path, { replace: true });
  }, [ navigate ]);

  return null;
}
